const settingsContent = {
  title: '설정 관리 매뉴얼',
  content: `
  <div class="page-title">[설정 관리]</div>

# [개요]
설정 관리 기능은 웹사이트의 기본 정보와 회사 관련 콘텐츠를 효율적으로 관리하기 위한 도구입니다. 이 문서에서는 **회사 정보, 위치 정보, 약관 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 기본 정보 관리 | 회사 기본 정보 및 로고 설정 | 관리자 |
| 위치 정보 관리 | 회사 위치 및 연락처 정보 설정 | 관리자 |
| 약관 관리 | 이용약관 및 개인정보처리방침 관리 | 관리자 |
| 회사 소개서 | 회사 소개서 파일 업로드 관리 | 관리자 |

# [설정 항목]
모든 설정은 언어별로 입력이 가능하며, 우측 상단의 저장 버튼으로 일괄 저장됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 정보 | • 로고 이미지<br>• 회사명<br>• 주소<br>• 전화번호<br>• 팩스번호<br>• 저작권 문구 | • 웹사이트 로고<br>• 회사 기본 정보<br>• 연락처 정보<br>• 저작권 표시 문구 |
| 위치 정보 | • 위치 이미지<br>• 이메일<br>• 영업문의 이메일<br>• 채용문의 이메일<br>• 이동 링크<br>• 소개 텍스트 | • 회사 위치 지도<br>• 용도별 이메일 주소<br>• 관련 페이지 링크<br>• 회사 소개 문구 |
| 약관 설정 | • 이용약관<br>• 개인정보처리방침 | • 에디터로 내용 작성<br>• HTML 형식 지원 |
| 회사 소개서 | • 회사 소개서 파일 | • PDF 파일 업로드 |

> ⚠️ **주의사항**
> - 위치 이미지는 지도 이미지를 업로드해야 합니다.
> - 저장 시 모든 언어의 내용이 일괄 저장됩니다.

### 📋 언어별 입력 가이드
| 구분 | 설명 |
|------|------|
| 기본 정보 | • 회사명, 주소, 저작권 문구는 언어별로 입력<br>• 전화번호, 팩스번호는 공통 사용 |
| 위치 정보 | • 소개 텍스트는 언어별로 입력<br>• 이메일 주소는 공통 사용 |
| 약관 | • 이용약관과 개인정보처리방침은 언어별로 작성<br>• 에디터에서 직접 작성 또는 HTML 입력 |

> 💡 **Tip**
> - 약관 등록 시 에디터의 미리보기로 실제 화면 표시를 확인할 수 있습니다.
> - 회사 소개서는 언어별로 다른 파일을 업로드할 수 있습니다.
> - 저장하기 전에 모든 언어의 필수 항목이 입력되었는지 확인하세요.

![언어별 설정](/assets/images/guide/settings/list.png)
  `,
};

export default settingsContent;
